module.exports = {
  appName: 'wheelDraw',
  DEBUG_FLAG: false, // 本地调试开关, 关联 getAppInfo 方法
  PUBLIC_PATH: '/gcp/luckyDraw/',
  BASE_PATH: '/gcp/luckyDraw/',
};
